var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39961 4.79883C1.95779 4.79883 1.59961 5.157 1.59961 5.59883C1.59961 6.04065 1.95779 6.39883 2.39961 6.39883H21.5996C22.0414 6.39883 22.3996 6.04065 22.3996 5.59883C22.3996 5.157 22.0414 4.79883 21.5996 4.79883H2.39961ZM1.59961 11.9988C1.59961 11.557 1.95779 11.1988 2.39961 11.1988H21.5996C22.0414 11.1988 22.3996 11.557 22.3996 11.9988C22.3996 12.4407 22.0414 12.7988 21.5996 12.7988H2.39961C1.95779 12.7988 1.59961 12.4407 1.59961 11.9988ZM1.59961 18.3988C1.59961 17.9571 1.95779 17.5988 2.39961 17.5988H21.5996C22.0414 17.5988 22.3996 17.9571 22.3996 18.3988C22.3996 18.8406 22.0414 19.1988 21.5996 19.1988H2.39961C1.95779 19.1988 1.59961 18.8406 1.59961 18.3988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.55e334c42f8e09bb7cb6ef8ac29f822a.svg";
export { ForwardRef as ReactComponent };